__turbopack_context__.v({
  "active": "NavBar-module-scss-module__OYUhbW__active",
  "nav": "NavBar-module-scss-module__OYUhbW__nav",
  "navBar": "NavBar-module-scss-module__OYUhbW__navBar",
  "navContentDesktop": "NavBar-module-scss-module__OYUhbW__navContentDesktop",
  "navContentMobile": "NavBar-module-scss-module__OYUhbW__navContentMobile",
  "navItem": "NavBar-module-scss-module__OYUhbW__navItem",
  "navnoHeader": "NavBar-module-scss-module__OYUhbW__navnoHeader",
  "scrollingWrapper": "NavBar-module-scss-module__OYUhbW__scrollingWrapper",
  "withBack": "NavBar-module-scss-module__OYUhbW__withBack",
  "withMiniContactPanel": "NavBar-module-scss-module__OYUhbW__withMiniContactPanel",
});
